import {
  buildDistinctPayload,
  buildPinIdentity,
  findCustomerPinForBar,
  findHousePinForBar,
  PIN_KINDS
} from './refiningLotPinState'
import { extractDisplayWeight } from './weightUtils'

const hasWeight = weight => {
  const value = extractDisplayWeight(weight, 'troyOunces')
  return value !== null && value !== 0
}

export const parseLegacyBarsIntoPins = (legacyBars) => {
  const bars = Array.isArray(legacyBars) ? legacyBars : []
  const pins = []

  bars.forEach(bar => {
    if (hasWeight(bar.pinWeight)) {
      pins.push({
        ...buildPinIdentity(bar, PIN_KINDS.HOUSE),
        grossWeight: bar.pinWeight,
        assayLoss: bar.assayLoss || null
      })
    }
    if (hasWeight(bar.customerPinWeight)) {
      pins.push({
        ...buildPinIdentity(bar, PIN_KINDS.CUSTOMER),
        grossWeight: bar.customerPinWeight,
        assayLoss: null
      })
    }
  })

  return buildDistinctPayload(bars, pins)
}

export const projectPinsToLegacyBars = (bars, pins) =>
  (Array.isArray(bars) ? bars : []).map(bar => {
    const house = findHousePinForBar(bar, pins)
    const customer = findCustomerPinForBar(bar, pins)

    // Always emit pin fields so flag-off clear (null) reaches the backend.
    // Omit-fields "don't touch" is for weight-only payloads that never call this.
    return {
      ...bar,
      pinWeight: house?.grossWeight ?? null,
      assayLoss: house?.assayLoss ?? null,
      customerPinWeight: customer?.grossWeight ?? null
    }
  })
